module.exports = __webpack_public_path__ + "static/media/wine-main.0eb0e77f.jpg";